import { render } from "./Integrations.vue?vue&type=template&id=d67cbfdc"
import script from "./Integrations.vue?vue&type=script&lang=ts"
export * from "./Integrations.vue?vue&type=script&lang=ts"

import "./Integrations.vue?vue&type=style&index=0&id=d67cbfdc&lang=scss"
script.render = render

export default script